import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { TextButton, Typography } from 'seagull';
import { routes } from '~/constants';
import styles from './AssociatedClientLink.module.scss';
export const AssociatedClientLink = (param)=>{
    let { customer, showSeparator, testId } = param;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            showSeparator && /*#__PURE__*/ _jsx(Typography, {
                as: "span",
                className: styles.separator,
                children: "\xb7"
            }),
            /*#__PURE__*/ _jsx(TextButton, {
                bi: {
                    name: 'contact_associated_client'
                },
                skin: "primary",
                underline: "none",
                variant: "paragraph2",
                as: Link,
                to: routes.client(customer.customerId),
                testId: testId,
                children: customer.customerName
            })
        ]
    });
};
